import photo1 from '../photos/gallery/4-web-or-mls-Sage+Oak-4.jpg'
import photo2 from '../photos/gallery/7-web-or-mls-Sage+Oak-7.jpg'
import photo3 from '../photos/gallery/10-web-or-mls-Sage+Oak-10.jpg'
import photo4 from '../photos/gallery/12-web-or-mls-Sage+Oak-12.jpg'
import photo5 from '../photos/gallery/15-web-or-mls-Sage+Oak-15.jpg'
import photo6 from '../photos/gallery/22-web-or-mls-Sage+Oak-22.jpg'
import photo7 from '../photos/gallery/24-web-or-mls-Sage+Oak-24.jpg'
import photo8 from '../photos/gallery/25-web-or-mls-Sage+Oak-25.jpg'
import photo9 from '../photos/gallery/27-web-or-mls-Sage+Oak-27.jpg'
import photo10 from '../photos/gallery/31-web-or-mls-Sage+Oak-31.jpg'
import photo11 from '../photos/gallery/32-web-or-mls-Sage+Oak-32.jpg'
import photo12 from '../photos/gallery/34-web-or-mls-Sage+Oak-34.jpg'
import photo13 from '../photos/gallery/38-web-or-mls-Sage+Oak-38.jpg'
import photo14 from '../photos/gallery/39-web-or-mls-Sage+Oak-39.jpg'
import photo15 from '../photos/gallery/41-web-or-mls-Sage+Oak-41.jpg'
import photo16 from '../photos/gallery/42-web-or-mls-Sage+Oak-42.jpg'
import photo17 from '../photos/gallery/43-web-or-mls-Sage+Oak-43.jpg'
import photo18 from '../photos/gallery/44-web-or-mls-Sage+Oak-44.jpg'
import photo19 from '../photos/gallery/48-web-or-mls-Sage+Oak-48.jpg'
import photo20 from '../photos/gallery/50-web-or-mls-Sage+Oak-50.jpg'
import photo21 from '../photos/gallery/51-web-or-mls-Sage+Oak-51.jpg'
import photo22 from '../photos/gallery/57-web-or-mls-Sage+Oak-57.jpg'
import photo23 from '../photos/gallery/59-web-or-mls-Sage+Oak-59.jpg'
import photo24 from '../photos/gallery/60-web-or-mls-Sage+Oak-60.jpg'
import photo25 from '../photos/gallery/64-web-or-mls-Sage+Oak-64.jpg'
import photo26 from '../photos/gallery/65-web-or-mls-Sage+Oak-65.jpg'
import photo27 from '../photos/gallery/69-web-or-mls-Sage+Oak-69.jpg'
import photo28 from '../photos/gallery/70-web-or-mls-Sage+Oak-70.jpg'
import photo29 from '../photos/gallery/71-web-or-mls-Sage+Oak-71.jpg'
import photo30 from '../photos/gallery/73-web-or-mls-Sage+Oak-73.jpg'
import photo31 from '../photos/gallery/74-web-or-mls-Sage+Oak-74.jpg'
import photo32 from '../photos/gallery/75-web-or-mls-Sage+Oak-75.jpg'
import photo33 from '../photos/gallery/77-web-or-mls-Sage+Oak-77.jpg'
import photo34 from '../photos/gallery/81-web-or-mls-Sage+Oak-81.jpg'
import photo35 from '../photos/gallery/82-web-or-mls-Sage+Oak-82.jpg'
import photo36 from '../photos/gallery/83-web-or-mls-Sage+Oak-83.jpg'
import photo37 from '../photos/gallery/85-web-or-mls-Sage+Oak-85.jpg'
import photo38 from '../photos/gallery/89-web-or-mls-Sage+Oak-89.jpg'
import photo39 from '../photos/gallery/90-web-or-mls-Sage+Oak-90.jpg'
import photo40 from '../photos/gallery/91-web-or-mls-Sage+Oak-91.jpg'
import photo41 from '../photos/gallery/93-web-or-mls-Sage+Oak-93.jpg'
import photo42 from '../photos/gallery/95-web-or-mls-Sage+Oak-95.jpg'
import photo43 from '../photos/gallery/100-web-or-mls-Sage+Oak-100.jpg'


const getLocalImgs = () => {
  const photoListContainer = [
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo1,
      altText:'Sunlight entering the cabin foyer.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo2,
      altText:'Afternoon sunshine entering the main living room through a window wall.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo3,
      altText:'Main living room in sunset.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo4,
      altText:'Main living room lounge area with wine and beer on the coffee table.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo5,
      altText:'Main room with kitchen and guest bedroom in view.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo6,
      altText:'Main room dining table.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo7,
      altText:'Kitchen marble island set with plates.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo8,
      altText:'Kitchen with main lounge and window wall in the background.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo9,
      altText:'Keurig coffee maker on counter top next to donuts and fruit.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo10,
      altText:'Master bedroom with a window wall opposite the bed.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo11,
      altText:'Master bedroom chairs and coffee table. Window wall in the background.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo12,
      altText:'Master bedroom bed with porch entrance.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo13,
      altText:'Master bathroom with glass wall shower.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo14,
      altText:'Master bathroom tub with flowers.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo15,
      altText:'Master bathroom sink with flowers.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo16,
      altText:'Master bathroom entrance with separate doors for toilet and shower.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo17,
      altText:'Master bedroom porch overlooking valley.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo18,
      altText:'Master bedroom porch overlooking valley durring sunset.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo19,
      altText:'Inside master bedroom with porch doors open at sunset.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo20,
      altText:'Guest bedroom with porch doors.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo21,
      altText:'Guest bedroom with door to main living room.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo22,
      altText:'Guest bedroom porch overlooking valley.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo23,
      altText:'Guest bedroom porch with main living room entrance and valley.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo24,
      altText:'Guest bathroom with sink and shower.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo25,
      altText:'Lower level living room with fireplace and stairs.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo26,
      altText:'Lower level living room with window wall in late afternoon.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo27,
      altText:'Video arcade machine with pac man on.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo28,
      altText:'Lower level living room air hockey and foosball table.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo29,
      altText:'Board and card games with fireplace in the background.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo30,
      altText:'Lower level coffee table with charcuterie board and wine.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo31,
      altText:'Foosball with lower level window wall in the background.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo32,
      altText:'Cabin laundry room with hanging iron board.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo33,
      altText:'Lower level guest room with two beds and porch doors.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo34,
      altText:'Lower level guest room with porch doors open overlooking valley.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo35,
      altText:'Lower level bathroom with sink and shower.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo36,
      altText:'Lower level porch with valley and private driveway.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo37,
      altText:'Hot tub with towels overlooking valley.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo38,
      altText:'Hot tub with lower level living room entrance.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo39,
      altText:'Hot tub at night with guest bedroom entrance.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo40,
      altText:'Valley from cabin porch.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo41,
      altText:'Valley from upper level porch with wine.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo42,
      altText:'Valley with cabin from Driveway.'
    },
    {
      imgWidth: 2048,
      imgHeight: 1368,
      imgUrl: photo43,
      altText:'Cabin on hill with lush trees at night.'
    },
  ]
  return photoListContainer
}
export { getLocalImgs }
